<template>
  <div class="forgot-password-page">
    <v-form @submit.prevent="submit" class="forgot-password-page__form">
      <div class="forgot-password-page__title">Forgot Password?</div>
      <TextField label="Email" v-model="form.email" type="email" />
      <v-btn type="submit" block color="primary" elevation="0" rounded large>
        Reset Password
      </v-btn>
      <div class="text-center mt-5">
        <router-link to="/login">Login</router-link>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
    };
  },
  methods: {
    async submit() {
      await this.$store.dispatch("auth/resetPassword", this.form);
      this.$alert("Email instructions successfully sent");
      this.$router.push("/").catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.forgot-password-page {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: center;

  &__title {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    padding-bottom: 15px;
  }

  &__form {
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05);
    background: white;
    padding: 30px;
    max-width: 400px;
    width: 100%;

    &::v-deep {
      .text-field {
        margin-bottom: 20px;
        width: 100%;
      }
    }
  }
}
</style>
